<template>
	<div class="d-flex align-center flex-column">
		<v-alert
			v-for="(shownAlert, index) in alerts"
			:key="shownAlert.timestamp"
			:type="shownAlert.type"
			elevation="2"
			class="alert my-1"
			border="left"
			text
			dismissible
			@input="dismissAlert(shownAlert, index)"
		>
			{{ shownAlert.message }}
		</v-alert>
	</div>
</template>

<script>
import { AlertHandlingGetters } from '@/store/getters';
import { AlertHandlingActions } from '@/store/actions';

export default {
	name: 'AlertComponent',
	data() {
		return {
			shownAlerts: [],
		};
	},
	computed: {
		alerts() {
			return this.$store.getters[AlertHandlingGetters.ALERTS];
		},
	},
	created() {
		this.$store.subscribe((mutation) => {
			if (mutation.type === 'alertHandling/SET_ALERT') {
				this.shownAlerts.push(mutation.payload);
			}
		});
	},
	methods: {
		dismissAlert(alert, index) {
			this.$store.dispatch(AlertHandlingActions.UPDATE_ALERT, alert);
			this.shownAlerts.splice(index, 1);
		},
	},
};
</script>

<style lang="scss" scoped>
.d-flex {
	position: absolute;
	top: 2rem;
	width: 100%;

	.alert {
		max-width: 75%;
		background-color: white !important;
		z-index: 9999;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
	}
}
</style>
